// Temputech brand gold — shared accent for dark-theme orangish UI
// (logo, site names, menu initials, window chrome text).

export const BRAND_GOLD = "#f4cc8e";
export const BRAND_GOLD_HIGHLIGHT = "#ffe2aa";
export const BRAND_GOLD_SHEEN = "#fff6d8";
export const BRAND_GOLD_MID = "#e0b87a";
export const BRAND_GOLD_DEEP = "#d4a86a";
export const BRAND_GOLD_BORDER = "#f4cc8e4d";

/** Soft fill used behind brand accents (e.g. icon chips). */
export const BRAND_GOLD_FILL_10 = "rgba(244, 204, 142, 0.1)";
export const BRAND_GOLD_FILL_05 = "rgba(244, 204, 142, 0.05)";

/**
 * Raised 14ct-gold metallic lettering (site names, menu initials, etc.).
 * @param {{ light?: boolean, muted?: boolean }} [opts]
 *   muted — softer sheen for dense UI like site-card titles
 */
export function brandGoldMetallicTextSx({ light = false, muted = false } = {}) {
    const sheen = muted ? BRAND_GOLD_HIGHLIGHT : BRAND_GOLD_SHEEN;
    const highlight = muted ? BRAND_GOLD : BRAND_GOLD_HIGHLIGHT;
    const body = muted ? BRAND_GOLD_MID : BRAND_GOLD;
    const deep = muted ? "#c4954a" : BRAND_GOLD_DEEP;
    const edge = muted ? BRAND_GOLD_DEEP : BRAND_GOLD_MID;
    const topGlow = muted
        ? (light ? "rgba(244, 204, 142, 0.45)" : "rgba(244, 204, 142, 0.35)")
        : (light ? "rgba(255, 246, 216, 0.85)" : "rgba(255, 246, 216, 0.7)");

    if (light) {
        return {
            background: [
                "linear-gradient(180deg,",
                `${sheen} 0%,`,
                `${highlight} 12%,`,
                `${body} 32%,`,
                `${deep} 52%,`,
                `${body} 68%,`,
                `${highlight} 84%,`,
                `${edge} 100%)`,
            ].join(" "),
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            filter: [
                `drop-shadow(0 1px 0 ${topGlow})`,
                `drop-shadow(0 -1px 0 rgba(180, 130, 60, ${muted ? 0.35 : 0.4}))`,
                `drop-shadow(1px 0 0 rgba(255, 226, 170, ${muted ? 0.2 : 0.35}))`,
                `drop-shadow(-1px 0 0 rgba(160, 110, 45, ${muted ? 0.2 : 0.25}))`,
                `drop-shadow(0 2px 1px rgba(0, 0, 0, 0.24))`,
                `drop-shadow(0 3px 4px rgba(0, 0, 0, 0.16))`,
            ].join(" "),
        };
    }

    return {
        background: [
            "linear-gradient(180deg,",
            `${sheen} 0%,`,
            `${highlight} 14%,`,
            `${body} 34%,`,
            `${deep} 52%,`,
            `${body} 68%,`,
            `${highlight} 84%,`,
            `${edge} 100%)`,
        ].join(" "),
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        filter: [
            `drop-shadow(0 1px 0 ${topGlow})`,
            `drop-shadow(0 -1px 0 rgba(0, 0, 0, 0.55))`,
            `drop-shadow(1px 0 0 rgba(255, 226, 170, ${muted ? 0.18 : 0.35}))`,
            `drop-shadow(-1px 0 0 rgba(0, 0, 0, 0.35))`,
            `drop-shadow(0 2px 1px rgba(0, 0, 0, 0.5))`,
            `drop-shadow(0 4px 5px rgba(0, 0, 0, 0.35))`,
        ].join(" "),
    };
}

/** Flat Temputech wordmark gradient (header GrainWave title). */
export function brandGoldFlatTextSx() {
    return {
        color: BRAND_GOLD,
        background: `linear-gradient(135deg, ${BRAND_GOLD} 0%, ${BRAND_GOLD_HIGHLIGHT} 100%)`,
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))",
    };
}
